import { render, staticRenderFns } from "./report-compression.vue?vue&type=template&id=752940eb&scoped=true"
import script from "./report-compression.vue?vue&type=script&lang=js"
export * from "./report-compression.vue?vue&type=script&lang=js"
import style0 from "./report-compression.vue?vue&type=style&index=0&id=752940eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752940eb",
  null
  
)

export default component.exports